import { render, staticRenderFns } from "./PersonalCardComponent.vue?vue&type=template&id=403951c1&scoped=true"
import script from "./PersonalCardComponent.vue?vue&type=script&lang=js"
export * from "./PersonalCardComponent.vue?vue&type=script&lang=js"
import style0 from "./PersonalCardComponent.vue?vue&type=style&index=0&id=403951c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403951c1",
  null
  
)

export default component.exports